import { all } from 'redux-saga/effects'

import {
  addBranchSaga,
  getBranchesSaga,
  changeBranchSaga,
  deleteBranchSaga,
  getUsersSaga,
  getDepartmentsSaga,
  getCashboxSaga,
  addCashboxSaga,
  getEmployeesSaga,
  getDepartmentLeaderSaga,
  getChiefAccountantSaga,
  getAccountantSaga,
  getSeniorCommodityExpertSaga,
  getGoodsSpecialistSaga,
  getEmployeeSaga,
  getReasonsSaga,
  getAdImageSaga,
  deleteAdImageSaga, getDepartmentsTabSaga,
} from './handbookSaga'

import {
  addClientSaga,
  getCountrySaga
} from './clientAddSaga'

import {
  getCalculationSaga
} from './quickCalculationSaga'

import {
  getAvailableDepartmentsSaga,
  getWorkSessionSaga
} from './dashboardSaga'

import {
  getClientsSaga,
  composeProfilesSaga,
  printClientProfileSaga,
  getFullNameDealSaga,
  dealNumberSaga,
} from './clientsSaga'

import {
  getClientContractsSaga,
  addClientContractSaga,
  getClientContractSaga,
  getProlongCalculateSaga,
  addProlongCalculateSaga,
  changeClientContractSaga,
  getOperationsSaga,
  changeContractStatusSaga,
  changeContractStatusRefundSaga,
  changeContractStatusCloseSaga,
  getTransactionsSaga,
  getPaymentsAnnuitySaga,
  getPaymentPeriodAnnuitySaga,
  payAnnuityPeriodSaga,
  changePositionsContractSaga,
  transferDealsSaga,
  getInventoriesSaga,
  getInventoryDealsSaga,
  getDealsForTransferSaga,
  transferSaledSaga,
  overestimationDealsSaga,
  cancelOperationSaga,
  getPrintedFormSaga,
  getClientsCountSaga,
  cancelContractSaga,
  transferToRetentionSaga,
  getPartialQuenchingDataSaga,
  contractPartialQuenchingSaga,
  loadPraFileSaga,
  getAcceptanceCertificateSaga,
  closeAnnuityDealSaga,
  getPrintedFormAutoLombardSaga,
} from './contractSaga'

import {
  getListUsersSaga,
  getCurrentUserSaga,
  getConfigurationSaga
} from './userSaga'

import {
  searchJewelsSaga,
  getClientFacetsSaga,
  searchClientsSaga,
  globalSearchSaga,
  getDealFacetsSaga,
  searchDealsSaga,
  searchCriminalsSaga,
  searchGovernmentAgencySaga,
  searchDealNumbersSaga,
} from './searchSaga'

import {
  getLastTransactionSaga,
  getLastTransactionBatchSaga,
  editTransactionSaga
} from './transactionsSaga'

import { createMessageSaga, getMessagesSaga } from './kbExchangeSaga'

import {
  getClientInfoSaga,
  getClientCashBoxes,
  clientShortInfoSaga,
  changeClientInfoSaga,
  getClientDetailsSaga
} from './clientShortInfoSaga'

import { 
  sendMessageSaga,
  getNotificationsListSaga, 
} from './notificationSaga'
import {directoriesSaga} from "./directoriesSaga";
import {
  getMigrateClientsSaga,
  getMigrateDealsSaga,
  setIndexClientsSaga,
  setIndexDealsSaga
} from "./mcsIntegrationSaga";

import {
  watchRequests,
  watchRequest,
  watchApproveRequest,
  watchRejectRequestSaga,
  watchChangeHistory,
  watchRequestClientsSaga,
  watchFetchDocumentSaga,
  watchInProgressRequestSaga,
  watchSetComments,
  watchUpdateRequestSaga,
  watchCreateOneAppClientSaga,
  watchDebtLoadRequestSaga,
  watchCreditCalculationReportSaga,
  watchСancelRequestSaga, watchCreditRegisterSaga, withdrawCarDepositSaga, watchPaymentSchedule
} from './autoLombardSaga'

import { getDebtLoadListSaga,
   updateDebtLoadListSaga, 
   getDebtLoadCalculationSaga, 
   getClientLastDebtLoadSaga, 
   getDebtLoadGroupSaga,
   generateDebtOverLoadReportSaga,
   fetchDebtLoadReportSaga,
   calculateDebtLoadSaga } from "./debtLoadSaga";

export default function* rootSaga() {
  yield all([
    addBranchSaga(),
    getBranchesSaga(),
    changeBranchSaga(),
    deleteBranchSaga(),
    getUsersSaga(),
    getDepartmentsSaga(),
    addClientSaga(),
    getCountrySaga(),
    getCalculationSaga(),
    getAvailableDepartmentsSaga(),
    getWorkSessionSaga(),
    getClientsSaga(),
    getClientContractsSaga(),
    getPrintedFormAutoLombardSaga(),
    addClientContractSaga(),
    closeAnnuityDealSaga(),
    getClientContractSaga(),
    getProlongCalculateSaga(),
    addProlongCalculateSaga(),
    changeClientContractSaga(),
    getOperationsSaga(),
    getListUsersSaga(),
    changeContractStatusSaga(),
    changeContractStatusRefundSaga(),
    changeContractStatusCloseSaga(),
    getTransactionsSaga(),
    getPaymentsAnnuitySaga(),
    getPaymentPeriodAnnuitySaga(),
    payAnnuityPeriodSaga(),
    searchJewelsSaga(),
    searchDealNumbersSaga(),
    changePositionsContractSaga(),
    getCashboxSaga(),
    transferDealsSaga(),
    getInventoriesSaga(),
    getInventoryDealsSaga(),
    getDealsForTransferSaga(),
    transferSaledSaga(),
    overestimationDealsSaga(),
    cancelOperationSaga(),
    getPrintedFormSaga(),
    getClientsCountSaga(),
    addCashboxSaga(),
    getEmployeesSaga(),
    getDepartmentLeaderSaga(),
    getChiefAccountantSaga(),
    getAccountantSaga(),
    getSeniorCommodityExpertSaga(),
    getGoodsSpecialistSaga(),
    getEmployeeSaga(),
    getLastTransactionSaga(),
    getReasonsSaga(),
    getLastTransactionBatchSaga(),
    getCurrentUserSaga(),
    getClientFacetsSaga(),
    searchClientsSaga(),
    globalSearchSaga(),
    getDealFacetsSaga(),
    searchDealsSaga(),
    composeProfilesSaga(),
    cancelContractSaga(),
    searchCriminalsSaga(),
    printClientProfileSaga(),
    getMessagesSaga(),
    createMessageSaga(),
    transferToRetentionSaga(),
    getClientInfoSaga(),
    getClientCashBoxes(),
    clientShortInfoSaga(),
    changeClientInfoSaga(),
    getClientDetailsSaga(),
    editTransactionSaga(),
    searchGovernmentAgencySaga(),
    sendMessageSaga(),
    getNotificationsListSaga(),
    getPartialQuenchingDataSaga(),
    contractPartialQuenchingSaga(),
    getAdImageSaga(),
    deleteAdImageSaga(),
    getConfigurationSaga(),
    dealNumberSaga(),
    getFullNameDealSaga(),
    getDepartmentsTabSaga(),
    directoriesSaga(),
    loadPraFileSaga(),
    getAcceptanceCertificateSaga(),
    getMigrateClientsSaga(),
    getMigrateDealsSaga(),
    setIndexClientsSaga(),
    setIndexDealsSaga(),
    getDebtLoadListSaga(),
    updateDebtLoadListSaga(),
    getDebtLoadCalculationSaga(),
    getClientLastDebtLoadSaga(),
    getDebtLoadGroupSaga(),
    generateDebtOverLoadReportSaga(),
    fetchDebtLoadReportSaga(),
    calculateDebtLoadSaga(),
    watchRequests(),
    withdrawCarDepositSaga(),
    watchRequest(),
    watchApproveRequest(),
    watchRejectRequestSaga(),
    watchRequestClientsSaga(),
    watchFetchDocumentSaga(),
    watchInProgressRequestSaga(),
    watchUpdateRequestSaga(),
    watchChangeHistory(),
    watchSetComments(),
    watchCreateOneAppClientSaga(),
    watchDebtLoadRequestSaga(),
    watchCreditCalculationReportSaga(),
    watchPaymentSchedule(),
    watchСancelRequestSaga(),
    watchCreditRegisterSaga()
  ])
}
